import { useContext } from 'react';

import { StyledPaper } from '../../../../components/common';
import FarmContext from '../../../../store/farm-context';

import {
  CreditTerms,
  AdditionalConsents,
  SurchargesApplication,
  AnimalProduction,
  AdditionalIncome,
  FinancialBurdens,
  FinancialSector,
  AdditionalDocuments,
  Summary,
} from './AccordionFormItems';

export default function AccordionForm() {
  const farmCTX = useContext(FarmContext);

  return (
    <>
      {farmCTX.farmID !== null && (
        <>
          <StyledPaper sx={{ mt: 5 }}>
            <CreditTerms />
            <AdditionalConsents />
            <SurchargesApplication />
            <AnimalProduction />
            <AdditionalIncome />
            <FinancialBurdens />
            <FinancialSector />
            <AdditionalDocuments />
            <Summary />
          </StyledPaper>
        </>
      )}
    </>
  );
}
